import type { SVGProps } from 'react';

const CompactLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 40 36"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <mask
      id="mask0"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="36"
    >
      <path
        d="M2.01138 0.351562C1.40762 0.351562 0.9104 0.873334 0.9104 1.50691V20.477C0.9104 29.6639 6.53961 35.6457 15.2942 35.6457H22.7347C23.3384 35.6457 23.8357 35.1239 23.8357 34.4903V25.1543C23.8357 24.5208 23.3384 23.999 22.7347 23.999H17.9756C17.3718 23.999 14.5128 23.9058 14.5128 20.3839V1.50691C14.5128 0.873334 14.0156 0.351562 13.4119 0.351562H2.01138Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0)">
      <path
        d="M1.70945 -4.08203L30.0331 1.58292L23.0365 40.0822L-5.28711 34.4173L1.70945 -4.08203Z"
        fill="white"
      />
    </g>
    <mask
      id="mask1"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="16"
      y="5"
      width="24"
      height="31"
    >
      <path
        d="M17.283 5.4375C16.6793 5.4375 16.1643 5.95927 16.1643 6.61149V17.3078C16.1643 17.9414 16.6615 18.4632 17.283 18.4632H22.7169C23.3207 18.4632 25.4694 18.5563 25.4694 22.0969V34.489C25.4694 35.1226 25.9666 35.6443 26.5703 35.6443H37.9708C38.5746 35.6443 39.0896 35.1226 39.0896 34.489V20.6248C39.0896 11.4379 33.4604 5.4375 24.7058 5.4375H17.283Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1)">
      <path
        d="M35.4491 44.4395L5.65161 30.8735L19.8045 -3.33984L49.6021 10.2262L35.4491 44.4395Z"
        fill="white"
      />
    </g>
  </svg>
);

export default CompactLogo;
